import Container from '../../components/menu/Container';
import { useTranslation } from "react-i18next";

import { useEffect, useRef, useState } from 'react';
import postRelatorio from '../../service/postRelatorio';
import React from 'react';
import { Toolbar } from 'primereact/toolbar';
import { Messages } from 'primereact/messages';
import { Button } from 'primereact/button';
import { MultiSelect } from 'primereact/multiselect';
import { carregarFranquias } from '../../hooks/useFranquias';
import { FiltrarRelatorio } from '../../interface/FiltrarRelatorio';




export default function FiltrarClienteAtivoPage() {
  const { t } = useTranslation();
  const msgs = useRef<Messages>(null);
  const [selectedFranquias, setSelectedFranquias] = useState([]);
  const [franquias, setFranquias] = useState<any>([]);

  const salvarRelatorio = () => {
    const franquiasId: string[] = [];
    if (selectedFranquias && Array.isArray(selectedFranquias)) {
      selectedFranquias.forEach((franq: any) => franquiasId.push(franq.id));
    }
    const filtrarRelatorio: FiltrarRelatorio = { tipoRelatorio: 'CLIENTE_ATIVO_CSV', tipoArquivo: 'CSV', filtro: { franquias: franquiasId } };
    postRelatorio(filtrarRelatorio).then((data) => {
      if (msgs.current) {
        msgs.current?.clear();
        msgs.current?.show([
          { sticky: false, life: 10000, severity: 'success', summary: 'Sucesso', detail: data, closable: false }
        ]);
      }
    });
  }

  const endContent = (
    <React.Fragment>
      <div style={{ background: 'transparent' }}>
        <div className='grid'>
          <div className='col'>
            <div className="flex-auto" style={{ width: '21rem' }}>
              <label htmlFor="franquia" className="font-bold block mb-2">{t('franquia')} </label>
              <MultiSelect value={selectedFranquias} onChange={(e) => setSelectedFranquias(e.value)} options={franquias} optionLabel="nome" display="chip"
                placeholder="Selecione Franquias" filter className="w-full md:w-20rem" />
            </div>
          </div>
        </div>
      </div>
      <Button style={{ marginLeft: "2rem", backgroundColor: '#183462' }} label="Gerar" onClick={() => { salvarRelatorio() }} />
    </React.Fragment>
  );


  useEffect(() => {
    carregarFranquias().then(lista => {
      setFranquias(lista);
    })
  }, [])

  return (
    <Container>
      <div className="row">
        <div className="col-lg-12 mb-3">
          <div className="d-sm-flex align-items-center justify-content-between mb-4">
            <h1 className="h3 mb-0 text-gray"><i className="pi pi-filter" style={{ fontSize: '2.0rem' }}></i> {t('relatorioClienteAtivo')}</h1>
          </div>
        </div>
      </div>
      <Messages ref={msgs} />
      <div className="card">
        <Toolbar start={endContent} />
      </div>

    </Container>
  )
}
